// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d683a7b8","453":"86c58ec1","455":"0dd9db3b","977":"4a8169e6"}[chunkId] + ".chunk.js";
};